import _ from 'lodash';
import { SessionStore } from './session.store';
import { KvAgtModel } from 'app/models/kv.agt.model';
import { KvAgtBaseStore } from './kv.agt.base.store';

export class AgtFitnessPdfModel {
	constructor(agtId: number, items: any[]) {
		this.agtId = agtId;
		const trackerts = items.filter((i) => i.key === 't');
		const plans = items.filter((i) => i.key === 'p');
		this.trackerBms = trackerts.map((i) => i.bm);
		this.planBms = plans.map((i) => i.bm);
	}

	agtId: number;

	trackerBms: number[] = [];
	planBms: number[] = [];
}

export class KvAgtFitnesspdfStore {
	kvAgtStore: KvAgtBaseStore;

	constructor(session: SessionStore) {
		this.kvAgtStore = new KvAgtBaseStore(session);
		this.kvAgtStore.apiPath = 'api/kv_agt/fitnesspdf';
	}

	findByAgtId(agtId: number) {
		return this.items.find((i) => i.agtId === agtId);
	}

	items: AgtFitnessPdfModel[] = [];

	async load() {
		if (this.items.length > 0) {
			return this.items;
		}
		const data = await this.kvAgtStore.findAll();
		const res: any[] = [];
		data.forEach((item) => {
			const pdfitems = JSON.parse(item.valueString);
			res.push(new AgtFitnessPdfModel(item.agtId, pdfitems));
		});
		this.items = res;
		return this.items;
	}
}
